import React, {useState} from "react";
import {Button, Modal} from "antd";
import {usePermissions} from "react-admin";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCode} from "@fortawesome/free-solid-svg-icons";
import CodeEditorSheet, {codeModalProps} from "./CodeEditorSheet";

const ModalWithButton = ({handleOk, buttonTitle, editorType, initialValue = "", disabled = false}: {handleOk: Function, buttonTitle: string, editorType: string, initialValue?: any, disabled?: boolean}) => {
    const { permissions } = usePermissions();
    // Viewing is harmless, so the button always renders; only saving needs ADMIN.
    const readOnly = disabled || permissions !== "ADMIN";
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editorValue, setEditorValue] = useState(initialValue);
    const [errorMessage, setErrorMessage] = useState("");
    const openModal = () => {
        // Re-sync from the latest form value on every open so edits saved earlier
        // (or a remount of this component) never show a stale/empty editor
        setEditorValue(initialValue);
        setErrorMessage("");
        setIsModalOpen(true);
    };
    const closeModal = () => setIsModalOpen(false);
    const handleOk_ = () => {
        if (editorType === "json") {
            // Allow clearing the field (empty/whitespace-only value)
            if (!editorValue || (typeof editorValue === "string" && !editorValue.trim())) {
                setErrorMessage("");
                setIsModalOpen(false);
                handleOk(null);
                return;
            }
            try {
                if(typeof editorValue === "string")
                    JSON.parse(editorValue)
                setErrorMessage("");
                setIsModalOpen(false);
                handleOk(editorValue);
            } catch (e) {
                setErrorMessage('Invalid JSON. Please correct it before saving.')
            }
        }
    };

    return <>
        {/* Viewing is harmless, so the trigger opts out of any disabled context
            it sits in — a read-only form still has to be readable. What the
            modal then allows is decided by `readOnly` above. */}
        <Button disabled={false} onClick={openModal} icon={<FontAwesomeIcon icon={faCode} />}>
            {buttonTitle}
        </Button>
        <Modal {...codeModalProps(buttonTitle)}
               open={isModalOpen}
               onCancel={closeModal}
               onOk={handleOk_}
               footer={readOnly
                   ? [<Button key="close" onClick={closeModal}>Close</Button>]
                   : [
                       <Button key="back" onClick={closeModal}>Cancel</Button>,
                       <Button key="submit" type="primary" onClick={handleOk_}>Save</Button>
                   ]}
        >
            <CodeEditorSheet
                language={editorType}
                value={typeof editorValue === "string" ? editorValue : JSON.stringify(editorValue, null, 4)}
                onChange={setEditorValue}
                readOnly={readOnly}
                error={errorMessage}
                ariaLabel={buttonTitle}
            />
        </Modal>
    </>

}

export default ModalWithButton;
